import React from "react";
import { Link } from "react-router-dom";
import EnvelopeIntro from "../components/EnvelopeIntro";
import walkingAndTalking from "../assets/WalkingAndTalking.jpeg";
import puttingRingOn from "../assets/PuttingRingOn.jpeg";
import hugging from "../assets/Hugging.jpeg";
import { isRsvpEnabled } from "../features";

const PHOTOS = [
  {
    src: walkingAndTalking,
    caption: "10.28.23",
  },
  {
    src: puttingRingOn,
    caption: "9.3.26",
  },
  {
    src: hugging,
    caption: "8.8.27",
  },
];

export default function Landing() {
  return (
    <>
      <EnvelopeIntro />
      <div className="hero">
        <section className="hero-copy">
          <p className="eyebrow">We're getting married</p>
          <h1>Ryan &amp; Lily</h1>
          <p className="hero-date">August 8, 2027</p>
          {isRsvpEnabled() && (
            <>
              <p className="intro">
                Save the date — we can't wait to celebrate with you. Please take a
                moment to RSVP and let us know if you'll be joining.
              </p>
              <Link to="/rsvp" className="button">
                RSVP now
              </Link>
            </>
          )}
        </section>

        <section className="gallery">
          {PHOTOS.map((p) => (
          <figure className="hero-photo" key={p.src}>
            <img src={p.src} alt={p.caption} loading="lazy" />
            <figcaption className="photo-caption">{p.caption}</figcaption>
          </figure>
          ))}
        </section>
      </div>
    </>
  );
}
